import { axiosClient } from '@nx-frontend/shared/api';
import { NoteServiceNoteExportParamsDto, TaskResponseDto } from '@nx-frontend/shared/types';

export interface ClientExportNoteParams {
  workspaceId: string;
  noteId: string;
  options: NoteServiceNoteExportParamsDto;
}

export async function clientExportNote(params: ClientExportNoteParams): Promise<TaskResponseDto> {
  const { data } = await axiosClient.post<TaskResponseDto>(
    `/v2/api/workspaces/${params.workspaceId}/notes/${params.noteId}/export`,
    params.options,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
}
